import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LANG_OPTIONS, BASE_HREF, LS_LANG, DEFAULT_LANG } from 'src/app/core/utils/constants';
import { WebserviceValorDato } from 'src/app/core/entities/webservicevalordato.model';
import * as _ from 'lodash';
import { Xmlfields } from 'src/app/core/entities/xmlfields.model';

@Component({
  selector: 'app-dialogs-datosws',
  templateUrl: './dialogs-datosws.component.html',
  styleUrls: ['./dialogs-datosws.component.scss']
})
export class DialogsDatoswsComponent implements OnInit {

  loading: boolean = true;
  codeWs: string = "";
  codeXml: string = "";
  datows: WebserviceValorDato[] = new Array<WebserviceValorDato>();
  etiquetas: Xmlfields[] = Array<Xmlfields>();
  idioma: string = "";
  cat: string = "";
  esp: string = "";
  entorno: string = "";

  valorTrue: boolean = true;
  valorFalse: boolean = false;

  langOption: any[] = LANG_OPTIONS;
  readonly DOWNLOAD: String = BASE_HREF + '/assets/images/download-w.svg';

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() private dialogRef: MatDialogRef<DialogsDatoswsComponent>) { }

  ngOnInit(): void {
    this.idioma = localStorage.getItem(LS_LANG) || DEFAULT_LANG;
    this.datows = _.cloneDeep(this.data.datos);
    this.cat = _.cloneDeep(this.data.cat);
    this.esp = _.cloneDeep(this.data.esp);
    this.codeWs = _.cloneDeep(this.data.wscode);
    this.etiquetas = _.cloneDeep(this.data.etiquetas);
    this.codeXml = _.cloneDeep(this.data.wscodexml);
    this.entorno = _.cloneDeep(this.data.entorno);
    this.loading = false;
  }

  /**
  * @description
  * Comprueba si el valor del dato coincide con su etiqueta y correspondiente tipado del mismo
  * @param item1 Posicion que ocupan los valores del WS
  * @param item2 Posicion que ocupa el formato del valor seleccionado
  * @param error Verdadero o Falso
  */
  public tipadoRegistros(item1: number, item2: number){
    if(item1 == item2){
      return true;
    }else{
      return false;
    }
  }

}
